import { I18n } from "@assets/strings";
import React, { useCallback } from "react";
import { useServices } from "@core/servicesContext";
import { Group, GroupMemberRole } from "@domain/group/group";
import { useModalTools } from "@ui/modals/modalContext";
import { createToast } from "@ui/toasts/utils";
import { EditMembersModal } from "@ui/components/profile/community/editMembersModal";

export function useMembersEditor(group?: Group, displayedRole?: GroupMemberRole): (title: string) => void {
	const { userService } = useServices();
	const { createModal } = useModalTools();

	const openMembersModal = useCallback(
		(title: string): void =>
			group &&
			displayedRole &&
			createModal((close) => (
				<EditMembersModal
					group={group}
					title={title}
					onMembersChosen={async (members) => {
						try {
							await userService.inviteMembersToGroup(group.id, members, displayedRole);
							close();
							createToast(I18n.t("success"), I18n.t(`members.${group.type}.${displayedRole}.add.success`), "success");
						} catch {
							createToast(I18n.t("error"), I18n.t(`members.add.error`), "error");
						}
					}}
					close={close}
				/>
			)),
		[group, displayedRole]
	);

	return openMembersModal;
}
